// Maps a stored alignment value to a Tailwind text-align class. Defaults to left.
export const alignClass = (v) => ({ left: "text-left", center: "text-center", right: "text-right", justify: "text-justify" }[v] || "text-left");
